import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const PictureContainer = styled.picture`
  > img {
    display: inline-block;
    height: auto;
    width: 100%;
  }
`;

const Picture = ({ img }) => (
  <PictureContainer>
    <img src={img} alt="section_image" />
  </PictureContainer>
);

Picture.propTypes = {
  img: PropTypes.object.isRequired,
};

export default Picture;
